<template>
  <div class="p-fluid p-formgrid p-grid">
    <div class="p-field p-col p-col-12 p-md-12 p-lg-12" style="font-size: 16px">
      <Panel header="Tra cứu thông tin CLS của bệnh nhân">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col p-col-12 p-md-6 p-lg-3">
            <label style="font-size: 16px">Mã y tế</label>
            <div class="card flex flex-column md:flex-row gap-3">
            <InputGroup>
              <InputNumber :useGrouping="false"  id="name" placeholder="Nhập mã bệnh nhân..." v-model="maYTe" style="text-align: center;font-size: 16px"  v-on:keyup.enter="loadListCls()" />
<!--              <Button label="Xóa" icon="pi pi-pi-trash" iconPos="left" severity="danger" />-->
              <Button label="Xóa" icon="pi pi-delete-left" severity="danger" iconPos="left" @click="deleteData()" style="font-size: 16px"/>
            </InputGroup>
            </div>
          </div>
          <div class="p-field p-col p-col-12 p-md-12 p-lg-12" v-if="openCamera" >
              <div class="stream">
                <StreamBarcodeReader
                    :zoom="3"
                    :autofocus="true"
                    @decode="onDecode"
                    @loaded="onLoaded"
                />
              </div>
          </div>
          <div class="p-field p-col p-col-6 p-md-6 p-lg-3">
            <label style="font-size: 16px">Quét mã bệnh nhân</label>
            <Button label="Quét mã" icon="pi pi-barcode" severity="warning" iconPos="left" @click="scanBarcode()" style="font-size: 16px"/>
          </div>
          <div class="p-field p-col p-col-6 p-md-6 p-lg-3">
            <label style="font-size: 16px">Tra cứu</label>
            <Button label="Tìm" icon="pi pi-search" iconPos="left" @click="loadListCls()" style="font-size: 16px"/>
          </div>
        </div>
      </Panel>
    </div>
      <div class="p-field p-col p-col-12 p-md-12 p-lg-12" style="font-size: 16px">
      <Panel header="Thông tin bệnh nhân" v-if="listCLS.length > 0">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col p-col-12 p-md-3 p-lg-3">
            <label style="font-size: 16px">Mã y tế</label>
            <InputText id="maYTe" type="text" v-model="listCLS[0].mayte" style="text-align: center;font-size: 16px" disabled/>
          </div>
          <div class="p-field p-col p-col-12 p-md-3 p-lg-3">
            <label style="font-size: 16px">Họ và tên</label>
            <InputText id="hoVaTen" type="text" v-model="listCLS[0].tenbenhnhan" style="text-align: center;font-size: 16px" disabled/>
          </div>
          <div class="p-field p-col p-col-12 p-md-3 p-lg-3">
            <label style="font-size: 16px">Số điện thoại</label>
            <InputText id="soDienThoai" type="text" v-model="listCLS[0].sodienthoai" style="text-align: center;font-size: 16px" disabled/>
          </div>
          <div class="p-field p-col p-col-12 p-md-3 p-lg-3">
            <label style="font-size: 16px">Ngày sinh</label>
            <InputText id="ngaySinh" v-model="ngaySinh" type="text" style="text-align: center;font-size: 16px" disabled>
            </InputText>
          </div>
        </div>
      </Panel>
        </div>
      <div class="p-field p-col p-col-12 p-md-12 p-lg-12" style="font-size: 16px">
      <Panel header="Chọn thời gian trả kết quả cho bệnh nhân" v-if="listCLS.length > 0">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col p-col-12 p-md-6 p-lg-4">
            <label style="font-size: 16px">Chọn thời gian</label>
            <Dropdown id="permission" v-model="result.minute" :options="listTime" optionLabel="label" optionValue="value" placeholder="Vui lòng chọn thời gian hoàn thành xét nghiệm ...">
            </Dropdown>
          </div>
          <div class="p-field p-col p-col-12 p-md-3 p-lg-3">
            <label style="font-size: 16px">Thực hiện</label>
            <Button label="Thực hiện" icon="pi pi-calendar-clock" severity="danger" iconPos="left" @click="createResultNotification()" style="font-size: 16px"/>
          </div>
        </div>
      </Panel>
        </div>
  </div>
</template>

<script lang="ts">

import moment from 'moment';
import { computed, ref } from 'vue'
import { useToast } from "primevue/usetoast";
import { useRouter } from 'vue-router'
import {useStore} from "vuex";
import zaloRepository from "@/services/ZaloRepository";
import {FilterMatchMode} from "primevue/api";
import {Ds_Cls} from "@/models/ds_Cls";
import {FileDetail} from "@/models/fileDetail.models";
import axios from "axios";
import {Cls} from "@/models/cls";
import {VueQrcodeReader} from 'vue-qrcode-reader';
import { StreamBarcodeReader } from '@teckel/vue-barcode-reader'
import {ResultNotification} from "@/models/resultNotification";


// import { StreamBarcodeReader } from "vue-barcode-reader";



export default {
  components: { StreamBarcodeReader },
  methods: {
    onDetect(detectedCodes) {
      console.log("#####$$$$$$$$$$ onDetect: " );
      console.log(detectedCodes)
  //result.value = JSON.stringify(detectedCodes.map((code) => code.rawValue))
},
//     onResult(result: Result | undefined) {
//       console.log("#####$$$$$$$$$$ onDetect: " );
// }
  },
  setup(){
    const router = useRouter();
    const toast = useToast();
    const store = useStore();
    const error = ref(null);
    const maYTe = ref("");
    const listCLS = ref([] as Ds_Cls[]);
    const ngaySinh = ref("")
    const permissionCLS = ref(false);
    const result = ref({} as ResultNotification);
    const listTime = ref([
      { label: '15 Phút', value: 15 },
      { label: '30 Phút', value: 30 },
      { label: '45 Phút', value: 45 },
      { label: '1 Tiếng', value: 60 },
      { label: '2 Tiếng', value: 120 },
      { label: '4 Tiếng', value: 240 },
      { label: '8 Tiếng', value: 480 },
      { label: '1 Ngày', value: 1440 },
    ]);

    if((store.state.permission == 'cls')){
      permissionCLS.value = true;
    }

    const loadListCls = () => {
      console.log("#####$$$$$$$$$$ loadListCls: " );
      zaloRepository.getDanhSachCls(maYTe.value)
          .then((response) => {
            console.log("#####$$$$$$$$$$ loadListCls 0000000: " );
            listCLS.value = response.data;
            console.log("#####$$$$$$$$$$ listCLS: " + JSON.stringify(listCLS.value));
            console.log("#####$$$$$$$$$$ listCLS.value.length: " + listCLS.value.length);
            if(listCLS.value.length < 1){
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail:'Bệnh nhân không có chỉ định cận lâm sàn',
                life: 2000
              });
            }
            if(listCLS.value[0].ngaysinh != null)
            {
              ngaySinh.value = formatDate(listCLS.value[0].ngaysinh);
            }
            console.log("#####$$$$$$$$$$ listCLS.value.length aaaa: ");
          })
          .catch(err => {
            console.log("#####$$$$$$$$$$ loadListCls 1111111: " );
            console.log("#####$$$$$$$$$$ loadListCls 1111111aaa : " + JSON.stringify(err.response));
            console.log("#####$$$$$$$$$$ loadListCls 1111111bbb : " + JSON.stringify(err.response.data));
            // console.log("#####$$$$$$$$$$ listCLS: " + JSON.stringify(err));
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:'Lỗi khi tải dữ liệu',
              life: 2000
            });
          });
    }

    const filters = ref({
      'global': {value: null, matchMode: FilterMatchMode.CONTAINS}
    });

    const clearFilter = () => {
      initFilters();
    };

    const initFilters = () => {
      filters.value = {
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      }
    };

    const formatDateTime = (date) => {
      console.log("@@@@@@@@@################ formatDateTime date: " + date.value);
      if((date == null)||(date == ''))
      {
        return "chưa có thông tin"
      }
      else
        return moment(String(date)).format('HH:mm:ss DD/MM/YYYY');
    };

    const formatDate = (date) => {
      console.log("@@@@@@@@@################ formatDateTime date: " + date.value);
      if((date == null)||(date == ''))
      {
        return "chưa có thông tin"
      }
      else
        return moment(String(date)).format('DD/MM/YYYY');
    };


    const createResultNotification = () => {
      // console.log("#####$$$$$$$$$$ createResultNotification: " );
      // console.log("#####$$$$$$$$$$ createResultNotification listCLS[0].value: " + JSON.stringify(listCLS[0].value));
      // console.log("#####$$$$$$$$$$ createResultNotification listCLS.value: " + JSON.stringify(listCLS.value[0]));
      result.value.phoneNumber = listCLS.value[0].sodienthoai;
      // result.value.phoneNumber = "0905333122";
      result.value.fullName = listCLS.value[0].tenbenhnhan;
      zaloRepository.createResultNotification(result.value)
          .then((response) => {
            toast.add({
              severity: 'success',
              summary: 'Thành công',
              detail:'Thêm thành công lịch trả kết quả',
              life: 2000
            });
            maYTe.value = "";
            const temp = ref({} as ResultNotification);
            result.value = temp.value;
          })
          .catch(err => {
            // console.log("#####$$$$$$$$$$ createResultNotification 1111111: " );
            // console.log("#####$$$$$$$$$$ createResultNotification 1111111aaa : " + JSON.stringify(err.response));
            // console.log("#####$$$$$$$$$$ createResultNotification 1111111bbb : " + JSON.stringify(err.response.data));
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2000
            });
          });
    }



    const isLoading = ref<boolean>(false)
    function onLoading(loading: boolean) {
      isLoading.value = loading
    }

    const decodedText = ref('')
    const openCamera = ref(false);

    const onDecode = (result) => {
      // console.log('onDecode #############')
      // console.log('onDecode ############# result: ' + result);
      openCamera.value = false;
      maYTe.value = result;
      loadListCls();
    }

    const onLoaded = () => {
      console.log('loaded')
    }
    const scanBarcode = () =>{
      openCamera.value = true;
      maYTe.value = "";
    }

    const deleteData = () => {
      listCLS.value = [];
      maYTe.value="";
    }

    return {
      scanBarcode,
      openCamera,
      decodedText,
      onDecode,
      error,
      filters,
      clearFilter,
      initFilters,
      maYTe,
      formatDateTime,
      listCLS,
      listTime,
      ngaySinh,
      permissionCLS,
      onLoaded,
      isLoading,
      onLoading,
      loadListCls,
      result,
      createResultNotification,
      deleteData
    }
  }
}

</script>
